import React from "react";
import CrudApp from "./components/CrudApp";

const App = () => {
  return (
    <div className="App">
      <CrudApp />
    </div>
  );
};

export default App;
